import { Modal, Button, message } from 'antd';
import React, { Component } from 'react';
//from ant
import { Form, Select, Input, Spin, Row, Col, Icon, Upload } from 'antd';
import { FaCheck, FaTimes, FaPlus, FaSave } from 'react-icons/fa'
//from material ui
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';

//action
import modalActions from '../../../redux/organization/actions';

const { Option } = Select;
const { TextArea } = Input;

const initialState = {
	data: [],
	value: [],
	fetching: false,
	preDeputy_id: [],
	preMember_id: [],

	boss_id: 0,
	boss_display_name: "Chua Co Cap Truong",

	avatarOrgani: '',
	imageUrl: '',
	loading: false,

	listBoss: [],
	listDeputy: [],
	listMember: [],
	loadListUser: true,

};

class ModalOrgani extends React.Component {
	constructor(props) {
		super(props)
		this.state = initialState;
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.currentOrganization !== this.props.currentOrganization) {

			console.log("tcurrentOrganization: ", nextProps.currentOrganization)
			const { form, currentOrganization } = nextProps
			this.setState({
				loading: false,
				imageUrl: nextProps.currentOrganization.ext_data.avatarOrgani
			})

			if (nextProps.currentOrganization.role_id !== this.props.currentOrganization.role_id) {
				form.setFieldsValue({ role: this.getNameRoleOrg(nextProps.currentOrganization) })

			}

			if (nextProps.currentOrganization.ext_data.description) {
				form.setFieldsValue({ description: nextProps.currentOrganization.ext_data.description })
			} else {
				form.setFieldsValue({ description: '' })
			}

			form.setFieldsValue({ organizationName: currentOrganization.name })

			if (currentOrganization.type !== null) {
				form.setFieldsValue({ type: currentOrganization.type })
			} else {
				form.setFieldsValue({ type: [] })
			}

			if (currentOrganization.boss_id === 0) {
				form.setFieldsValue({ boss_name: [] })
			}
			if (currentOrganization.deputy_id.length === 0) {
				console.log("1 currentOrganization.deputy_id: ", currentOrganization.deputy_id)
				form.setFieldsValue({ deputy: [] })
			} else {

			}
			if (currentOrganization.member_ids.length === 0) {
				form.setFieldsValue({ member: [] })
			}
		}

		if (nextProps.listBoss !== this.props.listBoss) {
			const { form, currentOrganization } = nextProps
			console.log(" 1 nextProps.listBoss: ", nextProps.listBoss)
			this.filterUser(nextProps.listBoss).then((listFilterd) => {
				console.log(" 2 listFilterd: ", listFilterd)

				this.setState({
					listBoss: listFilterd, fetching: false
				}, () => {
					console.log(" 3 nextProps.listBoss: ", [currentOrganization.boss_id])

					if (currentOrganization.boss_id === 0) {
						form.setFieldsValue({ boss_name: [] })
					} else {
						form.setFieldsValue({ boss_name: [currentOrganization.boss_id] })
					}
				})
			})
		}

		if (nextProps.listDeputy !== this.props.listDeputy) {
			console.log("this.props.listDeputy: ", nextProps.listDeputy)
			this.filterUser(nextProps.listDeputy).then((liestFilterd) => {
				this.setState({
					listDeputy: liestFilterd, fetching: false
				})
				if (nextProps.currentOrganization.deputy_id.length > 0) {
					nextProps.form.setFieldsValue({ deputy: nextProps.currentOrganization.deputy_id })
				} else {
					nextProps.form.setFieldsValue({ deputy: [] })
				}
			})
		}

		if (nextProps.listMember !== this.props.listMember) {
			this.filterUser(nextProps.listMember).then((liestFilterd) => {
				this.setState({
					listMember: liestFilterd, fetching: false
				}, () => {
					if (nextProps.currentOrganization.member_ids.length > 0) {
						nextProps.form.setFieldsValue({ member: nextProps.currentOrganization.member_ids })
					} else {
						nextProps.form.setFieldsValue({ member: [] })
					}
				})
			})
		}

	}

	componentDidMount() {
		console.log("componentDidMount")
		const { form, currentOrganization } = this.props

		form.setFieldsValue({ organizationName: currentOrganization.name })

		if (currentOrganization.ext_data.description) {
			form.setFieldsValue({ description: currentOrganization.ext_data.description })
		} else {
			form.setFieldsValue({ description: '' })
		}

		if (currentOrganization.type !== null) {
			form.setFieldsValue({ type: currentOrganization.type })
		} else {
			form.setFieldsValue({ type: [] })
		}
		if (currentOrganization.boss_id > 0) {
			form.setFieldsValue({ boss_name: [currentOrganization.boss_id] })
		} else {
			form.setFieldsValue({ boss_name: [] })
		}
		if (currentOrganization.deputy_id.length > 0) {
			form.setFieldsValue({ deputy: currentOrganization.deputy_id })
		} else {
			form.setFieldsValue({ deputy: [] })
		}
		if (currentOrganization.member_ids.length > 0) {
			form.setFieldsValue({ member: currentOrganization.member_ids })
		} else {
			form.setFieldsValue({ member: [] })
		}

		this.setState({
			loading: false,
			imageUrl: this.props.currentOrganization.ext_data.avatarOrgani
		})
	}

	filterUser = (listSearched) => {
		return new Promise((resolve, reject) => {
			const { getFieldValue } = this.props.form
			const bossIdSelected = getFieldValue('boss_name');
			const listDeputyIdSelected = getFieldValue('deputy');
			const listMemberIdSelected = getFieldValue('member');
			let listConcated = bossIdSelected.concat(listDeputyIdSelected)
			listConcated = listConcated.concat(listMemberIdSelected)
			const listFiltered = listSearched.filter((itemFilter) => {
				const uid = listConcated.find(uid => {
					return uid === itemFilter.uid
				})
				if (uid) {
					return itemFilter.uid !== uid
				} else {
					return true
				}
			})
			resolve(listFiltered)
		})
	}

	getBase64 = (img, callback) => {
		const reader = new FileReader()
		reader.addEventListener('load', () => callback(reader.result))
		reader.readAsDataURL(img)
	}

	_handleChangeCreateAvata = info => {
		if (info.file.status === 'uploading') {
			this.setState({ loading: true, imageUrl: null })

		}
		if (info.file.status === 'done') {

			const { modalActionCreators } = this.props
			const { create_avatar_organiztion } = modalActionCreators

			create_avatar_organiztion(info.file.originFileObj)
		}
	}
	fetchUser = (keyword, type) => {
		this.setState({
			listBoss: [],
			listDeputy: [],
			listMember: [],
			fetching: true
		});
		const { searchMember } = this.props
		searchMember(keyword, type)
	};

	_handleSubmit = e => {
		e.preventDefault()
		this.props.form.validateFields((err, values) => {
			if (!err) {
				const { getFieldValue } = this.props.form
				const listMemberSelected = getFieldValue('member');
				const { modalActionCreators } = this.props
				const listDeputySelected = getFieldValue('deputy');
				const { updateCurrentOrganization } = modalActionCreators

				updateCurrentOrganization({ member_ids: listMemberSelected, deputy_id: listDeputySelected })
				const { saveOrganiCurrent, hideModal } = modalActionCreators
				saveOrganiCurrent()
				hideModal()
			}
		});
	};

	_handleOk = e => {
	};

	_handleCancel = e => {
		const { modalActionCreators } = this.props
		const { hideModal } = modalActionCreators
		hideModal()
	};
	_optionsSelect = (data, color) =>
		data.map(item =>
			<Select.Option key={item.uid} value={item.uid}>
				<Chip
					variant="outlined"
					style={{
						border: "none",
						color: `${color}`
					}}
					size="medium"
					avatar={
						<Avatar style={{
							fontSize: 18
						}} alt="Natacha" src={item.avatar} size="medium" />}
					label={item.display_name}
				/>
			</Select.Option>
		)
	renderCommon = () => {
		const { getFieldDecorator } = this.props.form
		const { fetching, imageUrl } = this.state;

		const { organiEditing, modalActionCreators, currentOrganization } = this.props
		const { updateCurrentOrganization } = modalActionCreators

		const uploadButton = (
			<div>
				{this.state.loading ? <Spin /> : <FaPlus />}
				<div className="ant-upload-text" style={{ fontSize: 13 }}>
					Upload avatar
               </div>
			</div>
		)

		const dummyRequest = ({ file, onSuccess }) => {
			setTimeout(() => {
				onSuccess("ok");
			}, 0);
		};

		return (
			<div>
				<Form.Item
					label={null}
					extra={null}
					style={{ marginLeft: '40%' }}
				>
					{getFieldDecorator('upload', {})(
						<Upload
							name="avatar"
							showUploadList={false}
							listType="picture-card"
							className="avatar-uploader"
							onChange={this._handleChangeCreateAvata}
							customRequest={dummyRequest}
							style={{ backgroundColor: 'white' }}
						>
							{imageUrl && imageUrl !== '' ? (
								<img
									src={imageUrl}
									alt="avatar"
									style={{ width: '100%' }}
								/>
							) : (
									uploadButton
								)}
						</Upload>
					)}
				</Form.Item>
				<Form.Item label="Tên Đơn Vị" required={true}>
					<Row>
						<Col span={13} >
							<Form.Item >
								{getFieldDecorator('organizationName', {
									rules: [{ required: true, message: 'Nhập Tên Đơn Vị', whitespace: true }],
									initialValue: organiEditing ? organiEditing.name : ''
								})(<TextArea
									allowClear
									size={35}
									rows={1}

									onChange={value =>
										updateCurrentOrganization({
											name: value.target.value,
										})
									}
									placeholder="Nhập Tên Đơn Vị"
								/>
								)}
							</Form.Item>
						</Col>
						<Col span={10} offset={1}>
							<Form.Item  >
								{getFieldDecorator('type', {
									rules: [{ required: true, message: 'Chọn Kiểu Đơn Vị' }],
									initialValue: organiEditing ? organiEditing.type : null
								})(
									<Select
										placeholder="Kiểu Đơn Vị"
										onChange={value => updateCurrentOrganization({ type: value })}
									>
										<Option value={0}>{"Quân Báo Trinh Sát"}</Option>
										<Option value={1}>{"Trung Tâm Trinh Sát"}</Option>
										<Option value={2}>{"Đơn Vị Vùng"}</Option>
									</Select>
								)}
							</Form.Item>
						</Col>
					</Row>
				</Form.Item>
				<Form.Item label="Cấp Trưởng" >
					{getFieldDecorator('boss_name', {
						rules: [{ required: false, message: 'Username is required!' }],
						//initialValue: [this.props.currentOrganization.boss_id] ? [this.props.currentOrganization.boss_id] : null
					})(<Select
						size="large"
						mode="multiple"
						placeholder="Nhập Từ Khóa Tìm Kiếm"
						notFoundContent={fetching ? <Spin size="small" /> : null}
						showArrow
						showSearch
						filterOption={false}
						onSearch={(keyword) => {
							this.fetchUser(keyword, 1)
						}}
						style={{ width: '100%' }}
						onSelect={value => {
							this.props.form.setFieldsValue({ boss_name: [value] })
							updateCurrentOrganization({ boss_id: value })
							setTimeout(() => {
								this.setState({
									listBoss: []
								})
							}, 100);
						}}
						onChange={
							value => {
								if (value.length === 0) {
									updateCurrentOrganization({ boss_id: 0 })
								}
							}
						}
					>
						{this._optionsSelect(this.state.listBoss, 'red')}
					</Select>)}
				</Form.Item>

			</div>
		)
	}

	_handleChangeDeputy = (e) => {
		const { modalActionCreators } = this.props
		const { updateCurrentOrganization } = modalActionCreators

		updateCurrentOrganization({ deputy_id: e })
	}
	getNameRoleOrg = (currentOrganization) => {

		let role = this.props.roles.find((role, index) => {
			return role.role_id === currentOrganization.role_id
		})
		if (role) {
			return role.role_name
		} else {
			return ''
		}
	}

	_selectMember = (e) => {
		const { modalActionCreators } = this.props
		const { updateCurrentOrganization } = modalActionCreators

		updateCurrentOrganization({ member_ids: e })
	}

	rowCount = (e) => {
		var currentText = e.target.value;
		//Now we need to recalculate the number of characters that have been typed in so far
		var characterCount = currentText.length;
		var charsPerPageCount = 56;
		var unitCount = Math.round(characterCount / charsPerPageCount);
		console.log("wordCount: ", unitCount)
	}

	_onChangeDescription = (value) => {
		this.rowCount(value)
		const { modalActionCreators, currentOrganization } = this.props
		const { updateCurrentOrganization } = modalActionCreators
		let { ext_data } = currentOrganization
		console.log("ext_data: ", ext_data)
		ext_data.description = value.target.value
		console.log("ext_data:2  ", ext_data)

		updateCurrentOrganization({ ext_data: ext_data })
	}

	renderEditting() {

		let xhtml = null;
		const { currentOrganization, form } = this.props;
		const { getFieldDecorator } = this.props.form;
		const { fetching } = this.state;

		if (currentOrganization && currentOrganization.oid) {
			xhtml = (
				<div >
					<Form.Item label="Cấp Phó" >
						{getFieldDecorator('deputy', {
							rules: [{ required: false, message: 'Username is required!' }],
							initialValue: this.props.currentOrganization.deputy_id ? this.props.currentOrganization.deputy_id : null
						})(<Select
							size="large"
							mode="multiple"
							placeholder="Nhập Từ Khóa Tìm Kiếm"
							notFoundContent={fetching ? <Spin size="small" /> : null}
							filterOption={false}
							onSearch={(keyword) => {
								this.fetchUser(keyword, 2)
							}}
							onChange={this._handleChangeDeputy}
							//onSelect = {this._selectMember}
							onSelect={value => {
								setTimeout(() => {
									this.setState({
										listDeputy: []
									})
								}, 100);
							}}
							style={{ width: '100%' }}
						>
							{this._optionsSelect(this.state.listDeputy, 'green')}
						</Select>)}
					</Form.Item>
					<Form.Item label="Nhân Viên" >
						{getFieldDecorator('member', {
							rules: [{ required: false, message: 'Username is required!' }],
							initialValue: this.props.currentOrganization.member_ids ? this.props.currentOrganization.member_ids : null
						})(
							<Select
								mode="multiple"
								size="large"
								//labelInValue
								//value={value}
								placeholder="Nhập Từ Khóa Tìm Kiếm"
								notFoundContent={fetching ? <Spin size="small" /> : null}
								filterOption={false}
								onSearch={(keyword) => {
									this.fetchUser(keyword, 3)
								}}
								onChange={this._selectMember}
								onSelect={value => {
									setTimeout(() => {
										this.setState({
											listMember: []
										})
									}, 200);
								}}
								style={{ width: '100%' }}
							>
								{this._optionsSelect(this.state.listMember, 'blue')}
							</Select>)}
					</Form.Item>
					<Form.Item label="Mô Tả Đơn Vị" >
						{getFieldDecorator('description', {
							rules: [{ required: false, message: 'Mô Tả Đơn Vị', whitespace: true }],
						})(
							<TextArea
								rows={4}
								onChange={this._onChangeDescription}
							/>
						)}
					</Form.Item>
					<Form.Item label="Quyền người dùng">
						{getFieldDecorator('role', {
							initialValue: this.getNameRoleOrg(this.props.currentOrganization)
						})(
							<Select
								placeholder="Xin mời chọn quyền người dùng"
								style={{ width: 300 }}
								onChange={value => {
									console.log('select', value)
									const { modalActionCreators } = this.props
									const { updateCurrentOrganization } = modalActionCreators

									updateCurrentOrganization({ role_id: value })
								}

								}
								defaultValue
							>
								{this.props.roles.map((role, index) => {
									return (
										<Option key={index} value={role.role_id}>
											{role.role_name}
										</Option>
									)
								})}
							</Select>
						)}
					</Form.Item>
				</div>
			);
		}
		return xhtml;
	}

	render() {
		const { showModal, title, titleButtonModal, component } = this.props

		return (
			<div >
				<Modal
					title={title}
					visible={showModal}
					onOk={() => this._handleOK()}
					onCancel={() => this._handleCancel()}
					centered
					footer={null}
					maskClosable={false}
					width={700}
					style={{ top: 20 }}
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 19 }} onSubmit={this._handleSubmit}>
						{!component && this.renderCommon()}
						{this.renderEditting()}
						{component}
						<Row type="flex" justify="end">
							<Col >
								<Button type="primary" htmlType="submit" disabled={this.state.loading} >
									{titleButtonModal}
								</Button>
							</Col>
							<Col offset={0.5} >
								<Button onClick={this._handleCancel} type="primary" style={{ marginLeft: 5, backgroundColor: 'red' }}>
									Hủy
                           </Button>
							</Col>
						</Row>
					</Form>
				</Modal>
			</div>
		);
	}
}

const WrappedApp = Form.create({ name: 'organizationModal' })(ModalOrgani);

WrappedApp.propTypes = {
	classes: PropTypes.object,
	title: PropTypes.string,
	titleButtonModal: PropTypes.string,
	showModal: PropTypes.bool,
	component: PropTypes.object,
	modalActionCreators: PropTypes.shape({
		hideModal: PropTypes.func,
		addOrganization: PropTypes.func,
		updateCurrentOrganization: PropTypes.func,
		setOrganizationEditing: PropTypes.func
	}),
	listAllUser: PropTypes.array,
	organiEditing: PropTypes.object,
	users: PropTypes.array,
	searchMember: PropTypes.func,
	currentOrganization: PropTypes.object,

	listDeputy: PropTypes.array,
	listBoss: PropTypes.array,
	listMember: PropTypes.array
};

const mapStateToProps = state => {

	return {
		showModal: state.organization.showModal,
		component: state.organization.component,
		title: state.organization.title,
		listAllUser: state.user.users,
		organiEditing: state.organization.organiEditing,
		titleButtonModal: state.organization.titleButtonModal,
		users: state.user.users,
		listUserSearched: state.organization.listUserSearched,
		currentOrganization: state.organization.currentOrganization,

		listBoss: state.organization.listBoss,
		listDeputy: state.organization.listDeputy,
		listMember: state.organization.listMember,
		roles: state.user.roles,

	};
};

const mapDispatchToProps = dispatch => {
	return {
		modalActionCreators: bindActionCreators(modalActions.action, dispatch),
		searchMember: (keyword, typeUser) => {
			dispatch(modalActions.action.searchMember(keyword, typeUser));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(WrappedApp)
